<template>
    <div id="musicplayer" class="closed">
        <div class="row video">
            <div class="title">
                <div class="button button-white button-center minify"><i class="iconify icon:mdi:chevron-down"></i></div>
                <div class="text" v-html="player.playlistName"></div>
                <div class="button button-white button-center options"><i class="iconify icon:mdi:dots-horizontal"></i></div>
            </div>

            <div id="ytplayer"></div>
            <div class="thumb" :style="songThumb"></div>

<!--             <div class="gradient">
                <div class="button button-white button-center fullscreen">
                    <i class="iconify icon:mdi:fullscreen"></i>
                </div>
            </div>  -->
        </div>

        <div class="artist">{{ player.song.artist }}</div>
        <div class="song">{{ player.song.name }}</div>

        <div class="button button-center button-white btn-next" @click="playerAction('next')" :class="{ 'inactive': !showNext }" v-if="playlist.length > 1">
            <i class="iconify icon:ic:outline-skip-next"></i>
        </div>

        <div v-if="2==1">
            <span v-show="player.state != 1 && player.state != 3" @click="playerAction('play')" class="play"><i class="iconify icon:mdi:play"></i></span>
            <span v-show="player.state == 1" @click="playerAction('pause')" class="pause"><i class="iconify icon:mdi-pause"></i></span>
            <span v-show="player.state == 3" class="buffer"><i class="iconify icon:icomoon-free:spinner8"></i></span>
        </div>

        <div @click="playerAction('close')" class="button button-white button-center btn-close"><i class="iconify icon:mdi-close"></i></div>

        <div class="seekbar">
            <div class="progress"></div>
        </div>

        <div id="page-song" class="container-fluid">
            <div class="row">
                <div class="col-sm-12 header">
                    <div class="row">
                        <div class="col-sm-12 player">
                            <div class="row" v-if="!hasNoVideo">
                                <div class="col-sm-12 p-h-10">
                                    <span v-show="this.player.state != 1 && this.player.state != 3" @click="playerAction('play')">
                                        <i class="iconify icon:ic:baseline-play-circle-filled-white btn-play" ></i>
                                    </span>

                                    <span v-show="this.player.state == 1 || this.player.state == 3" @click="playerAction('pause')">
                                        <i class="iconify icon:ic:sharp-pause-circle-outline btn-pause"></i>
                                    </span>

                                    <div class="button button-white button-center btn-next" @click="playerAction('next')" :class="{ 'inactive': !showNext }">
                                        <i class="iconify icon:ic:outline-skip-next"></i>
                                    </div>

                                    <div class="button button-white button-center btn-previous" @click="playerAction('previous')" :class="{ 'inactive': !showPrev }">
                                        <i class="iconify icon:ic:outline-skip-previous"></i>
                                    </div>

                                    <div class="clearfix"></div>
                                </div>

                                <div class="col-sm-12 track">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <span class="range-slider">
                                                <span class="range-slider-inner">
                                                    <input type="text" class="range-slider-hidden">
                                                    <span class="range-slider-rail"></span>
                                                    <span class="range-slider-fill"></span>
                                                    <span class="range-slider-knob"></span>
                                                </span>
                                            </span>
                                        </div>
                                        <div class="col-xs-6 text-left elapsed" v-html="formatSeconds(player.track.time)"></div>
                                        <div class="col-xs-6 text-right remaining" v-html="formatSeconds(player.track.duration)"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-else>
                                <br>
                            </div>
                        </div>

                        <div class="col-sm-12 info">
                            <p class="artist" v-html="player.song.artist"></p>
                            <p class="title" v-html="player.song.name"></p>

                            <p class="date-genre">{{ player.song.published_formatted }}&nbsp;&nbsp;&nbsp;{{ getGenres }}</p>
                            <p class="uploader" v-html="player.song.uploader.name" @click="openUploader"></p><br>

                            <p class="label label-primary">Available for licensing</p>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 actions">
                    <span @click="reviewSong('like')" class="button button-center btn-like" :class="{ 'selected': isReview('like') }">
                        <i class="iconify icon:ic:baseline-favorite-border"></i>
                        <i class="iconify icon:ic:baseline-favorite"></i>
                    </span>

                    <div class="button button-center btn-add-playlist" @click="showPlaylistManager">
                        <i class="iconify icon:ic:baseline-add-circle-outline"></i>
                    </div>

                    <span @click="reviewSong('dislike')" class="button button-center btn-dislike" :class="{ 'selected': isReview('dislike') }">
                        <i class="iconify icon:ic:baseline-block"></i>
                        <i class="iconify icon:ic:baseline-block"></i>
                    </span>

                    <div class="clearfix"></div>
                </div>

                <div class="col-sm-12">
                    <ul class="page-tabs c4">
                        <li @click="changeTab('#statistics')" :class="{'active' : isTab('#statistics')}">Statistics</li>
                        <li @click="changeTab('#messages')" :class="{'active' : isTab('#messages')}">Messages</li>
                        <li @click="changeTab('#share')" :class="{'active' : isTab('#share')}">Share</li>
                        <li @click="changeTab('#artwork')" :class="{'active' : isTab('#artwork')}">EPK</li>
                        <li @click="changeTab('#lyrics')" :class="{'active' : isTab('#lyrics')}">Lyrics</li>
                    </ul>
                </div>

                <div class="col-sm-12 tab-content no-padding">
                    <statistics-tab v-if="isTabRendered('#statistics')" v-show="isTab('#statistics')" :song="player.song"></statistics-tab>
                    <messages-tab-own v-if="isTabRendered('#messages') && isOwner" v-show="isTab('#messages')" :song="player.song"></messages-tab-own>
                    <messages-tab-other v-if="isTabRendered('#messages') && !isOwner" v-show="isTab('#messages')" :song="player.song"></messages-tab-other>
                    <share-tab  v-if="isTabRendered('#share')" v-show="isTab('#share')" :song="player.song"></share-tab>
                    <artwork-tab  v-if="isTabRendered('#artwork')" v-show="isTab('#artwork')" :song="player.song"></artwork-tab>
                    <lyrics-tab  v-if="isTabRendered('#lyrics')" v-show="isTab('#lyrics')" :song="player.song"></lyrics-tab>
                </div>

                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>
 
<script>
import 'vue-range-slider/dist/vue-range-slider.css';
export default {
    props: {
        takeSongs: { default: 10 },
    },

    components: {
        'statistics-tab': require('@/components/Song/Show/Tab/Statistics.vue').default,
        'messages-tab-own': require('@/components/Song/Show/Tab/MessagesOwn.vue').default,
        'messages-tab-other': require('@/components/Song/Show/Tab/MessagesOther.vue').default,
        'share-tab': require('@/components/Song/Show/Tab/Share.vue').default,
        'artwork-tab': require('@/components/Song/Show/Tab/Artwork.vue').default,
        'lyrics-tab': require('@/components/Song/Show/Tab/Lyrics.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },    

    data() {
        return {
            state: 'closed',
            playlist: [],
            endpoint: false,
            requestData: false,
            fetchedAllSongs: false,
            loading: false,
            streamInterval: false,
            firstPlay: false,

            player: {
                song: {
                    type: false,
                    id: 0,
                    name: 'NO SONG PLAYING',
                    artist: '- empty playlist -',
                    uploader: {
                        id: 0,
                        name: ''
                    },
                    views: 0,
                    review: 0,
                    followed: false,
                    genres: [],
                    thumb: false,
                    ytb: false,
                },
                volume: 100,
                state: 3,
                seeking: false,
                track: {
                    index: 0,
                    time: 0,
                    duration: 1
                },
                widget: false,
                playlistName: false,
                title: '< No Playlist Selected >'
            },

            tab: {
                active:'#statistics',
                rendered: {
                    '#statistics': true,
                    '#messages': false,
                    '#share': false,
                    '#artwork': false,
                }
            },            
        }
    },

    mounted() {
        this.listenForEvents();
        // window.onYouTubeIframeAPIReady = () => {
            setTimeout(() => {
                this.player.widget = new YT.Player('ytplayer', {
                    height: 0,
                    width: 0,
                    playerVars: {
                        'autoplay': 0,
                        'controls': 0,
                        'disablekb': 1,
                        'iv_load_policy': 3,
                        'modestbranding': 1,
                        'enablejsapi': 1,
                        'origin': 'https://mobile.soundfeedapp.com',
                        // 'webkit-playsinline': 1,
                        'playsinline': 1,
                        'fs': 0,
                        'rel': 0
                    },
                    events:{
                        'onReady': this.ytplayerReady,
                        'onStateChange': this.ytplayerStateChange,
                    }
                });                
            }, 500);
        // }

        var $mp = $("#musicplayer");
        var that = this;

        var y0 = 0, y1 = 0, y2 = 0, h, t1, t2;  // Time
        var minVelocity = 5; // Minimum px distance object must be dragged to enable momentum.
        var minDrag = 200;
        var maxH = $(window).height();
        var dragTransformInterval = false;

        //disable on iphone
        if (App.platform == 'ios2'){
            $mp.on('touchstart', (e) => {
                var Y = (e.touches[0].clientY || e.touches[0].pageY) - $mp.position().top + $mp.scrollTop();

                if (Y > 0 && Y < $mp.find('> .video .thumb').height()){
                    y1 = 0; y2 = 0;
                    h =  $mp.height();
                    y0 = e.touches[0].clientY ||  e.touches[0].pageY;
                }else{
                    h = false;
                }
            }).on('touchmove', (e) => {
                if (h === false) return;
                $mp.removeClass('minimized maximized').addClass('no-transition');
                $('main').addClass('no-transition');

                y1 = y2;
                y2 = e.touches[0].clientY ||  e.touches[0].pageY;

                $mp.css('height', Math.min(Math.max(56, h + y0 - y2), maxH));
                $('main').css('height', maxH - 56 - Math.min(Math.max(56, h + y0 - y2), maxH));

                this.dragTransformations();
            }).on('touchend', (e) => {
                if (h === false) return;

                // console.log('Touch RELEASED !!!');
                // dragTransformInterval = setInterval(() => { this.dragTransformations() }, 10);
                // setTimeout(() => { clearInterval(dragTransformInterval); }, 600);

                $mp.removeClass('no-transition');
                $('main').removeClass('no-transition');                

                if ( y2 - y0 > 200 ) $mp.scrollTop(0);
                //we drag up
                if ($mp.height() > h){
                    if ((y2 - y1 < -minVelocity) || ($mp.height() - h > minDrag)){
                        $mp.addClass('maximized'); $mp.scrollTop(0);
                        $('.page-content').addClass('hasPlayerMaxed');
                    }else{
                        $mp.addClass('minimized'); $mp.scrollTop(0);
                        $('.page-content').removeClass('hasPlayerMaxed');
                    }                
                }
                //we drag down
                else if($mp.height() < h){
                    if ((y2 - y1 > minVelocity) || ($mp.height() - h < -minDrag)){
                        $mp.addClass('minimized'); $mp.scrollTop(0);
                        $('.page-content').removeClass('hasPlayerMaxed');
                    }else{
                        $mp.addClass('maximized'); $mp.scrollTop(0);
                        $('.page-content').addClass('hasPlayerMaxed');
                    }              
                }
            })

            setInterval(() => { this.dragTransformations() }, 10);
        }

        $mp.on('click', (e) => {
            var mobileHeight = App.platform != 'android222' ? 0 : (maxH > 800 ? 49 : 26);

            var X = e.clientX || e.pageX;
            var Y = (e.clientY || e.pageY) - $mp.position().top - mobileHeight;

            if (X > 100 && X < 300 && Y > 0 && Y < 50){
                $mp.removeClass('minimized').addClass('maximized');
                $('.page-content').addClass('hasPlayerMaxed');
            }

            if (X < 100 && Y > 0 && Y < 50 && $mp.is('.minimized')){
                that.playerAction('toggle');
            }            
        })

        $mp.find('.title .minify').on('click', (e) => {
            setTimeout(() => {
                $mp.removeClass('maximized').addClass('minimized');
                $('.page-content').removeClass('hasPlayerMaxed');
                $mp.scrollTop(0);
            }, 250);            
        })

        $mp.on('scroll', () => { 
           if ($(window).height() + $mp.find("#page-song .page-tabs").offset().top > 180){
                if (!this.tab.active){
                    this.tab.active = '#statistics';
                    this.tab.rendered[this.tab.active] = true;
                }
            }            
        })

        // $mp.find('.full-player .seekbar').on('click', function(e){
        //     var seek = (e.pageX - 65) / $(this).width();
        //     $(this).find('.progress').css('width', seek * 100 +'%');
        //     that.playerAction('seek', seek);
        // })

        // $mp.find('.gradient .fullscreen').on('click', (e) => {
        //     setTimeout(() => {
        //         this.playerAction('fullscreen');
        //     }, 250);            
        // })

        // $mp.find('.gradient').on('click', (e) => {
        //     $mp.find('.gradient').toggleClass('visible');
        // })



        var isDragging = false;
        var $mptrack = $('#musicplayer #page-song .track');

        $mptrack.find('.range-slider-knob').draggable({
            axis: "x",
            containment: "parent",
            start : function( evt, ui ) { // Fires once
                isDragging = true;
            },

            drag : function( evt, ui ) { // Fires after start event, and continuously during drag
                ui.position.left += 7;
                ui.position.top = 10;

                var progress = ($(this).position().left - $(this).parent().position().left + 23) / $(this).parent().width() * 100;
                $mptrack.find('.range-slider-fill').css('width', `calc(${progress}%)`);
                that.player.seeking = true;
            },

            stop : function( evt, ui ) { // Fires once
                that.player.track.time = ($(this).position().left - $(this).parent().position().left + 23) / $(this).parent().width() * that.player.track.duration;
                that.playerAction('seek', that.player.track.time / that.player.track.duration);
                that.player.seeking = false;
            }
        });

        $mptrack.find('.range-slider').on('touchstart', (e) => {
            if ( isDragging ) return;

            var offset = (e.pageX || e.originalEvent.touches[0].pageX) - $mptrack.find('.range-slider-rail').offset().left;
            var max = $mptrack.find('.range-slider-rail').width();            
            var seek = Math.min(Math.max(offset, 0), max) / max;

            $mptrack.find('.range-slider-knob').css('left', Math.min(Math.max(offset, 0), max) + 'px');
            $mptrack.find('.range-slider-fill').css('width', `calc(${seek * 100}%)`);
            this.player.seeking = true;
        }).on('touchend', (e) => {
            if ( isDragging ){
                isDragging = false;
                return;
            }

            var offset = (e.pageX || e.changedTouches[0].pageX) - $mptrack.find('.range-slider-rail').offset().left;
            var max = $mptrack.find('.range-slider-rail').width();            

            var seek = Math.min(Math.max(offset, 0), max) / max;
            
            this.player.track.time = parseInt(this.player.track.duration * seek);
            this.playerAction('seek', seek);
            this.player.seeking = false;
        });        

        $mptrack.find('.range-slider-knob').tooltipster({
            theme: 'tooltipster-borderless',
            animation: 'grow',
            animationDuration: [0, 0],
        });

       $mptrack.find('.range-slider-knob').on('mousemove', (e) => {
            var offset = (e.pageX || e.originalEvent.touches[0].pageX) - $mptrack.find('.range-slider-rail').offset().left;
            var min = 0;
            var max = $mptrack.find('.range-slider-rail').width();

            var percent = Math.min(Math.max(offset, min), max) / max;
            var seconds = parseInt(this.player.track.duration * percent);

            $mptrack.find('.range-slider-knob').tooltipster('content', moment("2015-01-01").startOf('day').seconds(seconds).format('mm:ss'))
                                               .tooltipster('option', 'functionPosition', (instance, helper, position) =>{
                                                    position.coord.left = (e.pageX || e.originalEvent.touches[0].pageX) - 28;
                                                    position.target = (e.pageX || e.originalEvent.touches[0].pageX);
                                                    return position;
                                                })
                                               .tooltipster('reposition')
                                               .tooltipster('open');
        });

        this.$root.$on('request-access', () => {
            this.player.song.permission = true;
        });       
    },

    methods: {
        getSongs(append = false, autoplay = true) {
            if (this.loading) return;
            
            // console.log('getting new songs', this.playlist);

            this.loading = true;
            this.fetchedAllSongs = false; // we update the flag after getting confirmation from the server

            this.$http.post(this.endpoint, this.requestData).then((success) => {
                if (success.data.data.length < 1) {
                    this.fetchedAllSongs = true;
                }

                if (!append) {
                    this.playlist = this.buildPlaylistArray(success.data.data);
                    this.player.song = this.playlist[this.player.track.index];
                    
                    if (autoplay) this.player.widget.loadVideoById({videoId: this.player.song.ytb, suggestedQuality: 'hd1080'});
                    
                    this.requestData.skip += this.requestData.take;
                }else{
                    $.merge(this.playlist, this.buildPlaylistArray(success.data.data));
                    this.requestData.skip += this.takeSongs;
                }

                //refresh the computed stuff by altering variable?
                this.player.track.index++;
                this.player.track.index--;


                this.loading = false;
                // if ($('#musicplayer').is('.closed')){
                //     $('#musicplayer').removeAttr('class').addClass('opened minimized');
                // }
            }, (error) => {
                this.loading = false;                
            });
        },

        buildPlaylistArray(songs, playType = 'playlist') {
            var playlist = [];
            $.each(songs, (i, s) => {
                playlist.push({
                    id: s.id,
                    type: playType,
                    name: s.name,
                    artist: s.artist,
                    description: s.description,
                    lyrics: s.lyrics,
                    uploader: {
                        id: s.uploader.id,
                        name: s.uploader.name
                    },
                    published_formatted: s.published_formatted,
                    views: s.views,
                    review: s.review,
                    followed: s.followed_artist,
                    genres: s.genres,
                    thumb: s.picture_path,
                    ytb: s.video_provider_id,
                    video_providers: s.video_providers
                });
            });

            return playlist;
        },

        ytplayerReady (event){
            if (this.playlist.length){
                this.player.widget.loadVideoById({videoId: this.player.song.ytb, suggestedQuality: 'hd1080'});
                this.player.widget.pauseVideo();
            }

            this.streamInterval = setInterval(() => {
                this.player.track.time = this.player.widget.getCurrentTime();
                this.player.track.duration = this.player.widget.getDuration();
                this.$root.$emit('currentSongStream', this.player.track.duration, this.player.track.time, this.player.state);
            }, 1000);
        },

        ytplayerStateChange (event){
            this.player.state = event.data;
            if (!this.firstPlay && App.platform == 'android'){
                $('#musicplayer').addClass('click-to-play');
            }

            //unstarted / song changed
            if (this.player.state == -1){
                this.player.song.duration = this.player.widget.getDuration();
                this.player.widget.setVolume(this.player.volume);
            }

            // ended
            if (this.player.state == 0){
                this.playerAction('next');
                $('#musicplayer').removeClass('show-video show-video-fast');
            }

            // playing
            if (this.player.state == 1){
                this.firstPlay = true;
                $('#musicplayer').removeClass('click-to-play');

                this.player.widget.setVolume(this.player.volume);
                $('#musicplayer').addClass(this.player.track.time < 3 ? 'show-video' : 'show-video-fast');
            }

            // paused
            if (this.player.state == 2){
                $('#musicplayer').removeClass('show-video show-video-fast');
            }            

            // buffering
            if (this.player.state == 3){
                if (this.player.track.time < 3){
                    $('#musicplayer').removeClass('show-video show-video-fast');
                }
            }
        },

        dragTransformations(){
            var $mp = $('#musicplayer');
            var mW = $(window).width();
            var mH = $(window).height();
            var vW = 96 + Math.max(0, Math.min($mp.height() - 112, mW - 96));
            var cH = $mp.height() - 112;
            
            $mp.find('> .video').css({padding: Math.max(0, cH - 400)/(mH - 512) * 56 +'px 0px '+ Math.max(0, cH - 500)*0/2 +'px 0px'});
            // $mp.find('> .header').css({height: Math.max(0, cH - 400) / (mH - 512) * 56 +'px'});

            $mp.find('> .video').css({width: vW + 'px', height: vW * 9 / 16 +'px'});
            $mp.find('> .artist').css({left: (vW - 96) + 112 + 'px'});
            $mp.find('> .song').css({left: (vW - 96) + 112 + 'px'});

            $mp.find('> .btn-next, > .btn-close').css({
                fontSize: 24 - Math.min(24, Math.max(0, (vW - mW + 200) / 5)) + 'px',
                display: Math.max(0, (vW - mW + 200) / 5) > 24 ? 'none' : 'initial'
            });

            $mp.find('> .seekbar').css({opacity: 1 - Math.min(vW - 96, 30) / 30});
            // $mp.css({borderBottom:  2 - Math.min(vW - 96, 4)/2 +'px solid transparent'})

            // $mp.css({bottom: 56 - Math.min(vW - 96, 56) +'px'});
            // $('#footer').css({bottom: (cH > 100 ? -56 : 0) +'px'});
        },
 
        formatSeconds(seconds){
            seconds = isNaN(seconds) ? 0 : seconds;
            return moment("2015-01-01").startOf('day').seconds(seconds).format('mm:ss');
        },

        isTab(tab) {
            return this.tab.active == tab || (!this.tab.active && tab == '#statistics');
        },

        isTabRendered(tab) {
            return this.player.song.id ? this.tab.rendered[tab] : false;
        },

        changeTab(tab) {
            if (tab){
                this.tab.active = tab;
                this.tab.rendered[tab] = true;
            }

            this.scrollBottom();
        },

        showPlaylistManager(){
            this.$root.$emit('showPlaylistManager', this.player.song);
        },

        isReview(state) {
            return this.player.song.review == state;
        },

        changePage(route) {
            if ($('#musicplayer').is('.maximized')){
                $('#musicplayer').animate({ scrollTop: 0 }, 500);
                $('#musicplayer').removeAttr('class').addClass('opened minimized');
                $('.page-content').removeClass('hasPlayerMaxed');
            }

            this.showPlaylistPopup = false;
            this.$router.push(route);
        },

        openUploader() {
            $('#musicplayer').animate({ scrollTop: 0 }, 500);
            $('#musicplayer').removeAttr('class').addClass('opened minimized');
            $('.page-content').removeClass('hasPlayerMaxed');
            this.showPlaylistPopup = false;

            App.queryParams = this.player.song.uploader;
            this.$router.push({path: '/profile/' + this.player.song.uploader.id});
        },

        reviewSong(type) {
            navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
            if (navigator.vibrate) {
                navigator.vibrate(100);
            }

            if (this.player.song.review && this.player.song.review == type) return;
            this.player.song.review = type;

            this.$http.post(this.reviewEndpoint, {review: type}).then((success) => {
                // this.player.song.review = type;
                // this.$root.$emit('reviewSong', this.player.song.id, type);

                if (App.allowGtag) gtag('event', `${type}_song`, {
                    'event_category' : 'song',
                    'event_label' : `${ type.charAt(0).toUpperCase() + type.slice(1) } ${ this.isOwner ? 'own' : 'other user'} song`
                });                
            }, (error) => {
                
            });            
        },

        playerAction(action, value = false){
            if (action == 'next' && this.showNext == true){
                $('.seekbar .progress').css('width', '0%');
                this.player.track.time = 0;

                this.player.track.index++;
                this.player.song = this.playlist[this.player.track.index];
                this.player.widget.loadVideoById({videoId: this.player.song.ytb, suggestedQuality: 'auto'});

                this.$root.$emit('currentSongPlaying', this.player.song.id);

                if ( this.player.track.index + this.takeSongs/2 > this.playlist.length && !this.fetchedAllSongs){
                    this.getSongs(true);
                }
            }

            if (action == 'previous' && this.showPrev == true){
                $('.seekbar .progress').css('width', '0%');
                this.player.track.time = 0;

                if (this.player.widget.getCurrentTime() < 5){
                    this.player.track.index--;
                    this.player.song = this.playlist[this.player.track.index];
                    this.player.widget.loadVideoById({videoId: this.player.song.ytb, suggestedQuality: 'auto'});

                    this.$root.$emit('currentSongPlaying', this.player.song.id); 
                }else{
                    this.player.widget.seekTo(0, true);
                    this.player.widget.playVideo();
                }
            }

            if (action == 'play'){
                this.player.widget.setVolume(this.player.volume);
                this.player.widget.playVideo();

                this.$root.$emit('currentSongPlaying', this.player.song.id); 
            }

            if (action == 'pause'){
                this.player.widget.setVolume(0);
                $('#musicplayer').removeClass('show-video show-video-fast').delay(500).queue((next) =>{
                   this.player.widget.pauseVideo(); next();
                });

                this.$root.$emit('currentSongPlaying', this.player.song.id, 'stopped'); 
            }

            if (action == 'toggle'){
                if (this.player.state != 1){
                    this.playerAction('play');
                }else{
                    this.playerAction('pause');
                }
            }

            if (action == 'seek'){
                this.player.widget.seekTo( parseInt(this.player.widget.getDuration() * value) , true);
            }

            if (action == 'close'){
                this.state = 'closed';
                $('#musicplayer').removeAttr('class').addClass('closed');
                $('.page-content').removeClass('hasPlayer');

                this.player.widget.stopVideo();
                if (this.player.song){
                    this.$root.$emit('currentSongPlaying', this.player.song.id, 'stopped');
                }
            }

            if (action == 'fullscreen'){
                if (!document.fullscreenElement){
                    document.documentElement.webkitRequestFullscreen();
                    $('.video').addClass('fullscreen');
                }else{
                    document.webkitExitFullscreen();
                    $('.video').removeClass('fullscreen');
                }
            }

            if (action == 'preload'){
                this.player.widget.pauseVideo({videoId: this.player.song.ytb, suggestedQuality: 'hd1080'});
            }
        },

        listenForEvents() {
            this.$root.$on('mp-load-playlist', (endpoint, reqData, playlistName = 'News Feed', startFrom = 0, songs = []) => {
                this.endpoint = endpoint;
                this.player.playlistName = `PLAYLIST: <b>${playlistName}</b>`;

                reqData.skip = 0;
                reqData.take = startFrom ? startFrom + this.takeSongs : this.takeSongs;
                this.requestData = reqData;

                this.player.track.index = startFrom ? startFrom - 1 : 0;
                this.state = this.state == 'closed' ? 'opened' : this.state;
                
                // this.playerAction('preload', songs[startFrom]);
                this.playlist = this.buildPlaylistArray([songs[startFrom - 1]]);
                this.player.song = this.playlist[0];
                this.player.widget.loadVideoById({videoId: this.player.song.ytb, suggestedQuality: 'hd1080'});
                
                this.$root.$emit('currentSongPlaying', this.player.song.id); 

                if ($('#musicplayer').is('.closed')){
                    $('#musicplayer').removeAttr('class').addClass('opened minimized');
                }

                this.getSongs(false, false);
            });

            this.$root.$on('mp-load-song', (song, openMaximized = false) => {
                this.player.playlistName = `SONG`;
                this.player.track.index = 0;
                this.state = this.state == 'closed' ? 'opened' : this.state;

                this.playlist = this.buildPlaylistArray([song], 'single');
                this.player.song = this.playlist[0];
                this.player.widget.loadVideoById({videoId: this.player.song.ytb});

                this.$root.$emit('currentSongPlaying', this.player.song.id); 

                // console.log(this.playlist, this.player);

                // if (this.playlist.length){
                //     if (this.player.song && this.player.song.id != song.id){
                //         openMaximized = this.player.song.id != 0;
                //         this.playlist.splice(this.player.track.index, 0, song);
                //     }
                // }

                if ( openMaximized ){
                    // setTimeout(() => {
                        $('main').addClass('no-transition');
                        $('#musicplayer').removeAttr('class').addClass('opened maximized no-transition');
                        $('.page-content').addClass('hasPlayer hasPlayerMaxed');
                        
                        setTimeout( () => {
                            $('#musicplayer, main').removeClass("no-transition");
                        }, 100);
                    // }, 300);
                }else{
                    $('#musicplayer').removeAttr('class').addClass('opened minimized');
                    $('.page-content').addClass('hasPlayer').removeClass('hasPlayerMaxed');
                }
            })

            this.$root.$on('playerAction', (action, value = false) => {
                this.playerAction(action, value);
            })

            this.$root.$on('requestCurrentSong', () => {
                this.$root.$emit('currentSongPlaying', this.player.song.id); 
            })

            this.$root.$on('reviewSong', (songId, review) => {
                $.each(this.playlist, (i, song) => {
                    if (song.id == songId){
                        song.review = review;
                    }
                });
            });             
        },

        scrollBottom(elem = '#musicplayer'){
            $(elem).animate({ scrollTop: $(elem).prop("scrollHeight")}, 400);
        },          
    },

    computed: {
        getGenres(){
            return this.player.song.genres.join(", ");
        },

        isOwner(){
            return App.user.id == this.player.song.uploader.id || App.user.id == 21;
        },

        songUrl() {
            return this.player.song.id ? '/song/' + this.player.song.id : '';
        },

        uploaderUrl() {
            return this.player.song.uploader.id ? '/profile/' + this.player.song.uploader.id : '';
        },

        songThumb() {
            return this.player.song ? "background-image: url('"+ App.restApi + '/api/image/' + this.player.song.thumb +"');" : "background-image: none;";
        },

        reviewEndpoint() {
            return App.restApi + '/api/song/' + this.player.song.id + '/review';
        },

        showPrev() {
            var a = this.playlist;
            return this.playlist.length ? this.player.track.index > 0 : false;
        },

        showNext() {
            return this.playlist.length > 1 ? (this.player.track.index < this.playlist.length - 1) : false;
        },

        hasNoVideo(){
            return this.player.song.ytb == 'soundfeed';
        },        
    },

    watch: {
        state(){ console.log('STATE', this.state);
            if (this.state != 'closed'){
                $('.page-content').addClass('hasPlayer');
                $('main').animate({ scrollTop: $('main').scrollTop() + 56 }, 300);
            }else{
                $('.page-content').removeClass('hasPlayer');
                $('main').animate({ scrollTop: $('main').scrollTop() - 56 }, 300);
            }
        },

        "player.track.time": function() {
            if (this.player.seeking) return;

            var max = $('.track .range-slider').width() - 14;
            var progress = this.player.track.duration ? this.player.track.time / this.player.track.duration * 100 : 0;
            var knobLeft = 7 + Math.min(progress/100 * max);

            $('#musicplayer .track .range-slider-knob').css('left', `${knobLeft}px`);
            $('#musicplayer .track .range-slider-fill, #musicplayer .seekbar .progress').css('width', `${progress}%`);
        },

        "player.song": function() {
            this.tab = {
                active: false,
                rendered: {
                    '#statistics': false,
                    '#messages': false,
                    '#share': false
                }
            };

            this.$nextTick(() => {
                var $mp = $("#musicplayer");
                if ($(window).height() - $mp.find("#page-song .page-tabs").offset().top > 180){
                    if (!this.tab.active){
                        this.tab.active = '#statistics';
                        this.tab.rendered[this.tab.active] = true;
                    } 
                }
            })
        }
    },
    
    beforeDestroy() {
        // this.$root.$off(['loadPlaylist', 'requestCurrentSong', 'reviewSong', 'playSong']);
        this.player.widget = false;
        clearInterval(this.streamInterval);
        console.log('Destroying MusicPlayer ..');
    }
}
</script>
